import { Component, OnInit, Input } from '@angular/core';
import { TreeControlNode } from '../../model/tree-control-node';
import { Nameable } from 'src/app/common/model/nameable';

@Component({
  selector: 'app-tree-item',
  templateUrl: './tree-item.component.html',
  styleUrls: ['./tree-item.component.scss']
})
export class TreeItemComponent<T extends Nameable> implements OnInit {

  @Input()
  node: TreeControlNode<T>;
  dataType: string;

  constructor() { }

  ngOnInit(): void {
    this.dataType = this.node.data.getClassName();
  }

}
